// src/lib/firebase/firestorePublic.js
// ======================================================
// 🔥 CONFIGURACIÓN PÚBLICA CENTRALIZADA (NIVEL ENTERPRISE)
// ======================================================
// ✅ SINGLETON: Solo una instancia de Firebase para páginas públicas
// ✅ Usa variables de entorno (VITE_FIREBASE_*)
// ✅ Zero hardcoded keys
// ✅ Compatible con las 3 páginas públicas
// ======================================================

import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";

/**
 * Obtiene la configuración desde variables de entorno.
 * En desarrollo usa VITE_*, en producción las mismas.
 */
const getFirebaseConfig = () => {
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };

  // Validar que no falten valores
  const missing = Object.entries(config).filter(([, v]) => !v);
  if (missing.length > 0) {
    console.error(
      "❌ [FirestorePublic] Faltan variables de entorno:",
      missing.map(([k]) => k).join(", ")
    );
  }

  return config;
};

// Singleton: solo una instancia
let publicDbInstance = null;

/**
 * Obtiene la instancia pública de Firestore (solo lectura).
 * Usa un nombre único para evitar conflictos con la app principal.
 */
export const getPublicDb = () => {
  if (publicDbInstance) return publicDbInstance;

  const config = getFirebaseConfig();
  const appName = "publicApp";

  // Verificar si ya existe una app con este nombre
  const existingApp = getApps().find((a) => a.name === appName);

  const app = existingApp || initializeApp(config, appName);
  publicDbInstance = getFirestore(app);

  console.log("✅ [FirestorePublic] Instancia pública inicializada");
  return publicDbInstance;
};

/**
 * Limpia la instancia (útil para testing).
 */
export const resetPublicDb = () => {
  publicDbInstance = null;
};

export default getPublicDb;
